import { render, staticRenderFns } from "./CashGoodsPage.vue?vue&type=template&id=4af2e87a&"
import script from "./CashGoodsPage.vue?vue&type=script&lang=js&"
export * from "./CashGoodsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports